import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { authProvider } from "./authProvider";
import AzureAD, { AuthenticationState } from "react-aad-msal";
import { Loader } from "./Loader";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());

if (params.leadId) {
  sessionStorage.setItem("leadId", params.leadId);
}

ReactDOM.render(
  <AzureAD provider={authProvider} forceLogin={true}>
    {({ login, logout, authenticationState, error, accountInfo }) => {
      switch (authenticationState) {
        case AuthenticationState.Authenticated:
          return (
            <Router>
              <Routes>
                <Route path={"/"} element={<App />}></Route>
              </Routes>
            </Router>
          );
        case AuthenticationState.InProgress:
          return <Loader />;
        default:
          return <p />;
      }
    }}
  </AzureAD>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
